import React, { FC } from 'react'
import { NextRouter } from 'next/router'
import MetaData from 'components/MetaData'
import { getPagePath } from 'selectors/page'
import parse from 'lib/url/parse'
import { getPageTitles } from './pageTitle'
import { PageInitialProps } from 'types/metadata'
import { User } from 'types/User'
import { Shared } from 'types/Shared'
import { Page } from 'types/Page'

type InitialState = {
  user: User
  shared: Shared
  page: Page
}

type AppMetadataProps = {
  initialProps?: PageInitialProps
  initialState: InitialState
  router?: NextRouter
}

const AppMetadata: FC<AppMetadataProps> = ({ initialProps, initialState, router }) => {
  const metaData = initialProps?.metaData
  const { og, title } = metaData || {}

  const urlPath = router?.asPath || getPagePath(initialState)
  const { query } = parse(urlPath)

  const { pageTitle, ogPageTitle } = getPageTitles(initialState, title, og?.title, query.page)

  return <MetaData pageMetaData={metaData} pageTitle={pageTitle} ogPageTitle={ogPageTitle} />
}

export default AppMetadata
